module.exports = __webpack_public_path__ + "app/components/global-search/devices-search.view.html";